import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { CreateStagedShipmentResult } from '../../core/api/lab.types';

export const createStagedShipmentHasErrorSelector = (state: RootState): boolean =>
  state.createStagedShipment.errors && state.createStagedShipment.errors ? true : false;

export const createStagedShipmentIsBusySelector = (state: RootState): boolean =>
  state.createStagedShipment.status === StoreStatus.BUSY;

export const createStagedShipmentResponseSelector = (state: RootState): CreateStagedShipmentResult | null =>
  state.createStagedShipment.response || null;
